var App = (function (app) {
    'use strict';

    app.prettify = function() {
        prettyPrint();
    }

    return app;
})(App || {});
